import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type UpdateShareCustomSortMutationVariables = Types.Exact<{
  shareId: Types.Scalars['ID']['input'];
  customSort?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;


export type UpdateShareCustomSortMutation = { __typename?: 'Mutation', updateShare?: { __typename?: 'UpdateSharePayload', share?: { __typename?: 'AdHocAssetsShare', customSort: boolean, id: string } | { __typename?: 'CollectionShare', id: string } | null } | null };


export const UpdateShareCustomSort = /*#__PURE__*/ gql`
    mutation UpdateShareCustomSort($shareId: ID!, $customSort: Boolean) {
  updateShare(input: {shareId: $shareId, settings: {customSort: $customSort}}) {
    share {
      id
      ... on AdHocAssetsShare {
        customSort
      }
    }
  }
}
    ` as unknown as DocumentNode<UpdateShareCustomSortMutation, UpdateShareCustomSortMutationVariables>;

          

          export const useUpdateShareCustomSortMutation = (options?:MutationHookOptions<UpdateShareCustomSortMutation, UpdateShareCustomSortMutationVariables>) => useMutation(UpdateShareCustomSort, options);
          

          export type UpdateShareCustomSortMutationOptions = MutationHookOptions<UpdateShareCustomSortMutation, UpdateShareCustomSortMutationVariables>;

          

          export type UpdateShareCustomSortMutationResult = ReturnType<typeof useUpdateShareCustomSortMutation>[1];

          
